// 🔒 BROWSER ENVIRONMENT SETUP - SECURE VERSION
// This file contains NO secrets - only public configuration
// Sensitive data is fetched securely from the server

(function() {
  'use strict';
  
  // Set up environment variables for browser (PUBLIC ONLY)
  window.__ENV__ = {
    // Firebase Configuration (will be populated securely from server)
    FIREBASE_API_KEY: '', // Will be populated by server securely
    FIREBASE_AUTH_DOMAIN: '', // Will be populated by server securely
    FIREBASE_PROJECT_ID: 'kt-shopify-apps', // Will be populated by server securely
    FIREBASE_STORAGE_BUCKET: '', // Will be populated by server securely
    FIREBASE_MESSAGING_SENDER_ID: '', // Will be populated by server securely
    FIREBASE_APP_ID: '', // Will be populated by server securely
    FIREBASE_MEASUREMENT_ID: '',
    
    // Public Shopify Configuration
    SHOPIFY_HOST: '', // Will be populated securely from server
    
    // Other configurations
    NODE_ENV: 'production'
  };
  
  // Function to get environment variable
  window.getEnvVar = function(key, fallback = '') {
    return window.__ENV__[key] || fallback;
  };
  
  // Function to securely load configuration from server
  window.loadSecureConfig = async function() {
    try {
      // Validate project ID before making request
      const projectId = window.__ENV__.FIREBASE_PROJECT_ID;
      if (!projectId) {
        return false;
      }

      // Circuit breaker: skip fetch if it failed recently (within 10 minutes)
      const lastFail = sessionStorage.getItem('firebaseConfigFail');
      if (lastFail && (Date.now() - parseInt(lastFail, 10)) < 600000) {
        return false;
      }

      const response = await fetch(`https://us-central1-${projectId}.cloudfunctions.net/getFirebaseConfig`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        signal: AbortSignal.timeout(5000)
      });

      if (response.ok) {
        const config = await response.json();
        if (config.success && config.config) {
          Object.assign(window.__ENV__, config.config);
          sessionStorage.removeItem('firebaseConfigFail');
          return true;
        } else {
          sessionStorage.setItem('firebaseConfigFail', Date.now().toString());
          return false;
        }
      } else {
        sessionStorage.setItem('firebaseConfigFail', Date.now().toString());
        return false;
      }
    } catch (error) {
      sessionStorage.setItem('firebaseConfigFail', Date.now().toString());
      return false;
    }
  };
  
  // Function to check if configuration is ready
  window.isConfigReady = function() {
    return !!(window.__ENV__.FIREBASE_API_KEY && 
              window.__ENV__.FIREBASE_AUTH_DOMAIN && 
              window.__ENV__.FIREBASE_PROJECT_ID);
  };
  
  // Function to wait for configuration to be ready
  window.waitForConfig = function() {
    return new Promise((resolve) => {
      if (window.isConfigReady()) {
        resolve(window.__ENV__);
      } else {
        // Listen for config loaded event
        window.addEventListener('secureConfigLoaded', () => resolve(window.__ENV__), { once: true });
        // Safety timeout — never hang forever if event never fires
        setTimeout(() => resolve(window.__ENV__), 5000);
      }
    });
  };
  
  // Browser environment setup complete

  // Auto-load configuration
  // NOTE: getFirebaseConfig Cloud Function is currently returning 500.
  // Disabled auto-fetch to eliminate console errors. Firebase features
  // degrade gracefully. Re-enable when Cloud Function is fixed by
  // uncommenting the loadSecureConfig() call below.
  // window.loadSecureConfig().then(function(success) {
  //   if (success) {
  //     window.dispatchEvent(new Event('secureConfigLoaded'));
  //   } else {
  //     window.dispatchEvent(new Event('secureConfigLoaded'));
  //   }
  // }).catch(function() {
  //   window.dispatchEvent(new Event('secureConfigLoaded'));
  // });

  // Skip config fetch — dispatch event immediately so initialization proceeds
  window.dispatchEvent(new Event('secureConfigLoaded'));
})();
